import { routeMeta, usePageMeta } from "../../lib/usePageMeta";
import { CERTIFICATION_STATUS } from "./trust";

const CONTROLS = [
  { title: "Tenant isolation", body: "Every record is scoped to one organization. Reads and writes across tenants are rejected, with no exceptions." },
  { title: "Authorization fails closed", body: "Missing authentication, membership, or entitlements deny access by default rather than allowing it." },
  { title: "Grounded AI only", body: "AI answers require supporting citations. Unsupported questions return a response that fails closed, never a guess." },
  { title: "Human verification", body: "Extractions and clauses carry verification state; humans confirm results with low confidence before reliance." },
  { title: "Secrets stored only as hashes", body: "Session tokens and API keys are stored only as hashes. Raw credentials are never persisted." },
  { title: "Hash chained audit", body: "Audit sensitive operations are recorded in logs that are only ever added to and are tamper evident." },
];

export function Security() {
  usePageMeta(routeMeta("/security"));
  return (
    <>
      <section className="hero">
        <div className="container">
          <span className="hero__eyebrow">Security &amp; Trust</span>
          <h1>Built to fail closed, for regulated work.</h1>
          <p className="lede">
            Odingard Studio inherits the platform&apos;s security posture: tenant isolation, provider neutral
            abstractions, and evidence ready for audit, designed for CMMC and DCAA programs.
          </p>
          <p className="lede">
            Your documents and prompts are never used to train public or shared AI models, and never to train a model
            for another customer. The model provider receives only the text a single request needs, and the record of
            what was sent stays in your organization&apos;s audit log.
          </p>
        </div>
      </section>
      <section className="section">
        <div className="container">
          <div className="feature-grid">
            {CONTROLS.map((c) => (
              <div className="feature" key={c.title}>
                <div className="feature__icon" aria-hidden="true">
                  🔒
                </div>
                <h3>{c.title}</h3>
                <p>{c.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section className="section">
        <div className="container">
          <div className="section__head">
            <h2>Certification status, stated plainly</h2>
            <p>Where an outside assessor has looked, and where one has not yet.</p>
          </div>
          <div className="feature-grid">
            {CERTIFICATION_STATUS.map((c) => (
              <div className="feature" key={c.framework}>
                <h3>{c.framework}</h3>
                <p>
                  <strong>{c.status}</strong> {c.detail}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
